export const MAX_LENGTH_GENERIC_FIELD = 255;
export const MIN_LENGTH_GENERIC_FIELD = 8;
